import React from "react";
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";
import Headline from "../../../components/Headline";
import SectionChipBar from "./SectionChipBar";

export default function EntryHeaderOverlay({
    visible,
    onOpenEntrySetting,
    columninfo,
    entrydata,
    chips,
    onChipClick
}) {
    // ENTRY FORM 系の時だけ右上ヘッダ領域を表示します。
    if (!visible) return null;

    return (
        <div>
            <div style={{ position: "absolute", top: 60, right: 15 }}>
                <IconButton
                    type="button"
                    size="small"
                    onClick={onOpenEntrySetting}
                    title={"レイアウト設定"}
                >
                    <Icon>table_chart</Icon>
                </IconButton>
            </div>
            <Headline columninfo={columninfo} entrydata={entrydata} />
            <SectionChipBar
                chips={chips}
                onChipClick={onChipClick}
            />
        </div>
    );
}
